import {Mapper} from '@s-ui/domain'

export class FromApiResponseToLoanCalculationsTransactionsValueObjectMapper extends Mapper {
  constructor({loanCalculationsTransactionsValueObjectFactory}) {
    super()
    this._loanCalculationsTransactionsValueObjectFactory = loanCalculationsTransactionsValueObjectFactory
  }

  map = params => {
    const {
      minEntry,
      maxEntry,
      availableTerms,
      fee,
      capital,
      openingExpenses,
      isOpeningExpensesFinanced,
      tin,
      tae,
      totalAmountDue,
      totalLoanAmount,
      openingPercentage,
      totalInterest,
      totalLoanCost
    } = params

    return this._loanCalculationsTransactionsValueObjectFactory({
      minEntry,
      maxEntry,
      availableTerms,
      fee,
      capital,
      openingExpenses,
      isOpeningExpensesFinanced,
      tin,
      tae,
      totalAmountDue,
      totalLoanAmount,
      openingPercentage,
      totalInterest,
      totalLoanCost
    })
  }
}
